const formatCurrencyString = value => {
  if (typeof value === 'number') {
    const currencyFormated = String(
      value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    );
    return currencyFormated;
  } else {
    return '';
  }
};

export default formatCurrencyString;
